<template>
  <div class="q-pa-md">
    <q-stepper
      v-model="step"
      header-nav
      :vertical="true"
      ref="stepper"
      color="primary"
      animated
    >
      <q-step
        :name="1"
        title="Basic infomation"
        icon="accessibility_new"
        :done="step > 1"
        :header-nav="step > 1"
      >
        <q-form @submit="onSubmitForm1">
          <div class="basic-info">
            <q-input
              outlined
              dense
              label="Phone number"
              mask="##########"
              unmasked-value
              v-model="form.phoneNumber"
              :rules="[
                (val) => !!val || 'Phone number is required',
                validatePhone,
              ]"
            ></q-input>
            <q-input
              outlined
              dense
              label="Customer firstname"
              v-model="form.customerFirstname"
              :rules="[(val) => !!val || 'firstname is required']"
            ></q-input>
            <q-input
              outlined
              dense
              label="Customer lastname"
              v-model="form.customerLastname"
              :rules="[(val) => !!val || 'lastname is required']"
            ></q-input>
            <q-input
              outlined
              dense
              label="Customer email"
              v-model="form.customerEmail"
              lazy-rules="ondemand"
              :rules="[validateEmail]"
            ></q-input>
          </div>
          <q-stepper-navigation>
            <q-btn type="submit" color="primary" label="Continue" />
          </q-stepper-navigation>
        </q-form>
      </q-step>

      <q-step
        :name="2"
        title="Shipping address"
        icon="map"
        :done="step > 2"
        :header-nav="step > 2"
      >
        <q-input
          outlined
          dense
          placeholder="Search address.. e.g. 10400"
          v-model="addressKeyword"
        ></q-input>
        <div class="location-list" v-if="predictList">
          <q-list bordered separator>
            <q-item
              clickable
              @click="selectedIndex = index"
              :active="index == selectedIndex"
              v-for="(address, index) in predictList"
              :key="index"
            >
              <q-item-section>{{ address.description }}</q-item-section>
            </q-item>
          </q-list>
        </div>
        <div ref="dummymap" />
        <div class="col-12 map" :style="getStyle">
          <GmapMap
            ref="map"
            :center="mapCenter"
            :zoom="15"
            map-type-id="roadmap"
            style="width: 100%; height: 100%"
            :options="{
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: false,
              disableDefaultUi: true,
              clickableIcons: false,
            }"
            @center_changed="updateCenter"
            @idle="sync"
            @dragstart="draging = true"
            @dragend="draging = false"
          >
          </GmapMap>
          <i class="fixed-marker fas fa-map-marker-alt" aria-hidden="true"></i>
        </div>
        <div class="text-subtitle2 text-accent">
          For speed of delivery and cost calculation, please move the coordinate
          as close as customer location as possible.
        </div>
        <div class="text-subtitle2 text-accent">
          เพิ่อให้การจัดส่งรวดเร็วและคำนวณค่าส่งได้ถูกต้อง
          กรุณาปักหมุดให้ใกล้กับที่อยู่ของลูกค้าให้มากที่สุด
        </div>
        <q-stepper-navigation>
          <q-btn
            @click="
              () => {
                done2 = true;
                step = 3;
                getLocationDetail(mapCenter);
              }
            "
            color="primary"
            label="Continue"
          />
          <q-btn
            flat
            @click="step = 1"
            color="primary"
            label="Back"
            class="q-ml-sm"
          />
        </q-stepper-navigation>
      </q-step>

      <q-step
        :name="3"
        title="Confirm infomation"
        icon="person_add"
        :header-nav="step > 3"
      >
        <q-form @submit="onSubmitForm3">
          <div class="text-h7 text-primary">- Contact infomation</div>
          <q-input
            dense
            disable
            label="Customer name"
            v-model="infomation.name"
          ></q-input>
          <q-input
            dense
            disable
            label="Phone number"
            v-model.trim="infomation.phoneNumber"
          ></q-input>
          <q-input
            dense
            disable
            label="Customer email (optional)"
            v-model.trim="infomation.email"
          ></q-input>
          <div class="text-h7 text-primary" style="padding-top: 10px">
            - Shipping address
          </div>
          <q-input
            dense
            label="Place name, e.g. My home / Office / Parent's home"
            v-model.trim="infomation.address.name"
            :rules="[(val) => !!val || 'place name is required']"
          ></q-input>
          <q-input
            dense
            label="Address detail, e.g. address no/ town/ street"
            v-model.trim="infomation.address.address"
            laz
            :rules="[(val) => !!val || 'address is required']"
          ></q-input>
          <q-input
            dense
            disable
            label="Sub district"
            v-model.trim="infomation.address.subDistrict"
          ></q-input>
          <q-input
            dense
            disable
            label="District"
            v-model.trim="infomation.address.district"
          ></q-input>
          <q-input
            dense
            disable
            label="Province"
            v-model.trim="infomation.address.province"
          ></q-input>
          <q-input
            dense
            disable
            label="Postcode"
            v-model.trim="infomation.address.postcode"
          ></q-input>
          <q-stepper-navigation>
            <q-btn
              :loading="loading"
              color="primary"
              label="Confirm"
              type="submit"
            />
            <q-btn
              flat
              @click="step = 2"
              color="primary"
              label="Back"
              class="q-ml-sm"
            />
          </q-stepper-navigation>
        </q-form>
      </q-step>
    </q-stepper>
  </div>
</template>

<script>
import { gmapApi } from "vue2-google-maps";
import { debounce } from "debounce";
import { QList, QItemSection, QItem } from "quasar";
const components = { QList, QItemSection, QItem };
// const google = window.google;

export default {
  name: "CreateCustomer",
  components: {
    ...components,
  },
  data() {
    return {
      step: 1,
      done1: false,
      form: {
        phoneNumber: null,
        customerFirstname: null,
        customerLastname: null,
        customerEmail: null,
      },
      addressKeyword: null,
      mapCenter: { lat: 13.736717, lng: 100.523186 },
      reportedMapCenter: { lat: 13.736717, lng: 100.523186 },
      currentPlace: null,
      predictList: [],
      selectedIndex: -1,
      infomation: {
        name: null,
        phoneNumber: null,
        email: null,
        address: {
          name: null,
          address: null,
          province: null,
          subDistrict: null,
          district: null,
          postcode: null,
          location: null,
          email: null,
          firstname: null,
          lastname: null,
          phone: null,
        },
      },
      address: {
        location: {
          lat: null,
          lng: null,
        },
      },
      loading: false,
    };
  },
  created() {
    console.log("created");
  },
  computed: {
    google: gmapApi,
    getStyle() {
      if (this.selectedIndex < 0) {
        return "display: none;";
      }
      return "";
    },
  },
  watch: {
    addressKeyword: {
      immediate: false,
      handler(val) {
        this.onQuery(val);
      },
    },
    selectedIndex: {
      immediate: false,
      handler(val) {
        console.log("selectedIndex");
        if (val == -1) {
          return;
        }
        this.onChooseAddress(this.predictList[val]);
      },
    },
  },
  methods: {
    validatePhone(val) {
      if (val.includes("-")) {
        return "phone number must not contain '-'";
      }
      let re = new RegExp(/([+0-9])\w+/g);
      if (val.match(re)) {
        return true;
      }
      return "phone number must be 0-9";
    },
    validateEmail(val) {
      if (val == null) {
        return true;
      }
      let re = new RegExp("[a-z0-9]+@[a-z]+[a-z]{2,3}");
      if (val.match(re)) {
        return true;
      }
      return "invalid email";
    },
    onSubmitForm1() {
      this.done1 = true;
      this.step = 2;
      this.infomation.phoneNumber = this.form.phoneNumber.trim();
      this.infomation.address.phone = this.form.phoneNumber.trim();
      this.infomation.address.firstname = this.form.customerFirstname;
      this.infomation.address.lastname = this.form.customerLastname;
      this.infomation.name = `${this.form.customerFirstname} ${this.form.customerLastname}`;
      if (this.form.customerEmail) {
        this.infomation.email = this.form.customerEmail;
        this.infomation.address.email = this.form.customerEmail;
      }
    },
    async updateCenter(latLng) {
      console.log("update center");
      this.reportedMapCenter = {
        lat: latLng.lat(),
        lng: latLng.lng(),
      };
    },
    sync() {
      console.log("sync!");
      this.mapCenter = this.reportedMapCenter;
      this.address = {
        ...this.address,
        location: {
          lat: this.reportedMapCenter.lat,
          lng: this.reportedMapCenter.lng,
        },
      };
    },
    async onQuery(keyword) {
      this.predictList = [];
      this.selectedIndex = -1;
      if (keyword === null) {
        return;
      }
      if (keyword === undefined) {
        return;
      }
      if (keyword === "") {
        return;
      }
      // const google = this.google;
      // console.log("Query with keyword: " + keyword);
      // console.log("Google: ", google);
      // const service = new google.maps.places.AutocompleteService();
      // service.getQueryPredictions(
      //   {
      //     input: keyword,
      //     location: new google.maps.LatLng(13.736717, 100.523186),
      //     radius: 550000,
      //   },
      //   (predictions, status) => {
      //     console.log("Query result: ", predictions);
      //     if (predictions) {
      //       predictions.forEach((item) => console.log(item.description));
      //       this.predictList = predictions;
      //     }
      //   }
      // );

      this.$services.googlemap
        .getPlaceList(keyword, String([13.736717, 100.523186]), 550000)
        .then((predictions) => {
          if (predictions) {
            predictions.forEach((item) => console.log(item.description));
            this.predictList = predictions;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async onChooseAddress(address) {
      // const google = this.google;
      // const service = new google.maps.places.PlacesService(this.$refs.dummymap);
      // const request = {
      //   placeId: address.place_id,
      //   fields: ["address_components", "geometry", "formatted_address"],
      // };

      // await service.getDetails(request, (result, status) => {
      //   this.address.location = {
      //     lat: result.geometry.location.lat(),
      //     lng: result.geometry.location.lng(),
      //   };
      //   this.reportedMapCenter = {
      //     lat: result.geometry.location.lat(),
      //     lng: result.geometry.location.lng(),
      //   };
      //   this.sync();
      //   console.log("getDetails:", result);
      // });

      this.$services.googlemap
        .getDetails(address.place_id, [
          "address_components",
          "geometry",
          "formatted_address",
        ])
        .then((result) => {
          console.log("getDetails result", result);

          this.address.location = {
            lat: result.geometry.location.lat,
            lng: result.geometry.location.lng,
          };
          this.reportedMapCenter = {
            lat: result.geometry.location.lat,
            lng: result.geometry.location.lng,
          };
          this.sync();
          console.log("getDetails:", result);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getAddressComponent(addressList) {
      addressList.forEach((address) => {
        address.address_components.forEach((ac) => {
          ac.types.forEach((t) => {
            if (
              t == "postal_code" &&
              this.infomation.address.postcode === null
            ) {
              console.log("postal code found", ac.long_name);
              this.infomation.address.postcode = ac.long_name;
            }
            if (
              t == "administrative_area_level_1" &&
              !this.infomation.address.province
            ) {
              console.log("province found", ac.long_name);
              this.infomation.address.province = ac.long_name;
            }
            if (
              t == "administrative_area_level_2" &&
              !this.infomation.address.district
            ) {
              console.log("district found", ac.long_name);
              this.infomation.address.district = ac.long_name;
            }
            if (t == "locality" && !this.infomation.address.subDistrict) {
              console.log("subdistrict found", ac.long_name);
              this.infomation.address.subDistrict = ac.long_name;
            }
          });
        });
      });
    },
    async onSubmitForm3() {
      try {
        this.loading = true;
        await this.$store.dispatch("sale/addNewCustomer", {
          firstname: this.form.customerFirstname,
          lastname: this.form.customerLastname,
          email: this.form.customerEmail,
          phone_number: this.form.phoneNumber.trim(),
          address: this.infomation.address,
        });
        this.$router.push({
          name: "Home",
        });
      } catch (error) {
        console.warn(error);
      } finally {
        this.loading = false;
      }
    },
    getLocationDetail: debounce(async function (latLng) {
      this.infomation.address.location = latLng;
      // const google = this.google;
      // const service = new google.maps.Geocoder();
      // const request = {
      //   location: latLng,
      // };

      // try {
      //   await service.geocode(request, (result, status) => {
      //     console.log("getGmapPostalCode:", result);
      //     this.getAddressComponent(result);
      //   });
      // } catch (err) {
      //   console.log(err);
      // }

      this.$services.googlemap
        .geocode(String([latLng.lat, latLng.lng]))
        .then((result) => {
          console.log("getGmapPostalCode:", result, latLng);
          this.getAddressComponent(result);
        })
        .catch((error) => {
          console.error(error);
        });
    }, 300),
  },
};
</script>

<style>

.fixed-marker-label {
  position: absolute;
  left: 50%;
  top: calc(50% - 40px);
  font-size: 12px;
  color: white;
  width: 70%;
  transform: translate(-50%, -50%);
  background-color: lightslategrey;
  padding: 4px;
}
.fixed-marker-label-address {
  color: white;
  font-weight: 600;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.fixed-marker {
  position: absolute;
  left: 50%;
  top: 50%;
  font-size: 28px;
  color: #c72027;
  transform: translate(-50%, -50%);
}
.map {
  position: relative;
  height: calc(50vh - 100px) !important;
}
.map-loading {
  display: grid;
  min-height: 300px;
  width: 100%;
}

</style>
